<template>
  <div :class="cn(priorityVariants({ priority, size }), props.class)">
    <span class="md:inline">
      {{ label }}
    </span>
  </div>
</template>

<script setup>
import { priorityVariants } from ".";
import { cn } from "@/Utils/cn";

const props = defineProps({
  priority: {
    type: String,
    required: true,
  },
  size: {
    type: String,
    required: false,
  },
  label: {
    type: String,
    required: true,
  },
  class: {
    type: null,
    required: false,
  },
});
</script>
